import * as React from "react";
const SvgMetrovacesaLogoShort = (props) => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    width={84}
    height={22}
    viewBox="47 -1 22 32"
    {...props}
  >
    <defs>
      <path id="metrovacesa_logo-short_svg__a" d="M0 0h115.9v30.9H0z" />
    </defs>
    <clipPath id="metrovacesa_logo-short_svg__b">
      <use xlinkHref="#metrovacesa_logo-short_svg__a" overflow="visible" />
    </clipPath>
    <g clipPath="url(#metrovacesa_logo-short_svg__b)">
      <defs>
        <path id="metrovacesa_logo-short_svg__c" d="M-115-24h1920v145H-115z" />
      </defs>
      <clipPath id="metrovacesa_logo-short_svg__d">
        <use xlinkHref="#metrovacesa_logo-short_svg__c" overflow="visible" />
      </clipPath>
      <g clipPath="url(#metrovacesa_logo-short_svg__d)">
        <defs>
          <path id="metrovacesa_logo-short_svg__e" d="M0 0h116v31H0z" />
        </defs>
        <clipPath id="metrovacesa_logo-short_svg__f">
          <use xlinkHref="#metrovacesa_logo-short_svg__e" overflow="visible" />
        </clipPath>
        <g clipPath="url(#metrovacesa_logo-short_svg__f)">
          <defs>
            <path
              id="metrovacesa_logo-short_svg__g"
              d="M115.6 30.3c.2 0 .3-.1.3-.3v-8.9c0-.2-.1-.3-.3-.3h-9c-.2 0-.3.1-.3.3V30c0 .2.1.3.3.3h9zM82.9 1.1c-1.8.7-3.3 1.8-4.6 3.1-1.2 1.4-2.2 3-2.8 4.9-.7 1.9-1 4-1 6.3s.3 4.4 1 6.3 1.6 3.5 2.8 4.9c1.2 1.4 2.7 2.4 4.6 3.2 1.8.7 3.9 1.1 6.3 1.1 3.8 0 6.9-.9 9.4-2.6 2.5-1.8 4-4.3 4.7-7.7 0-.2-.1-.3-.3-.3h-6.8c-.2 0-.3.1-.4.3-.5 1.3-1.2 2.3-2.2 3-.9.7-2.4 1.1-4.4 1.1-1.3 0-2.4-.2-3.3-.7s-1.7-1.1-2.3-1.9c-.6-.8-1.1-1.8-1.4-2.9s-.4-2.3-.4-3.6.1-2.5.4-3.6.8-2.1 1.4-2.9c.6-.8 1.4-1.5 2.3-1.9.9-.5 2-.7 3.3-.7 1.8 0 3.1.4 4.2 1.1 1 .7 1.8 1.7 2.3 3 .1.2.2.3.4.3h6.8c.2 0 .3-.1.3-.3-.5-3.2-2-5.7-4.5-7.5C96.1.9 93 0 89.1 0c-2.3 0-4.4.4-6.2 1.1zM59.6 23.6c0 .2-.1.2-.3.2s-.3-.1-.3-.2L51.8 1c-.1-.3-.2-.4-.4-.4h-6.9c-.1 0-.2 0-.3.1s-.1.2 0 .3l9.9 29c.1.2.2.3.4.3h9.7c.2 0 .3-.1.4-.3l9.9-29c.1-.3 0-.4-.3-.4h-6.8c-.2 0-.4.1-.5.4l-7.3 22.6zm-16.7 6.7c.2 0 .3-.1.3-.3V13.4c0-4.6-1.1-8-3.2-10.1C37.9 1.1 35 0 31.2 0c-1.9 0-3.5.4-4.8 1.1s-2.3 1.5-3.2 2.4c-.2.2-.3.2-.5 0-.8-1-1.8-1.8-3.1-2.5-1.3-.6-2.8-1-4.6-1-.7 0-1.4.1-2.1.3-.7.2-1.4.4-2.1.7-.6.2-1.2.5-1.8.9-.5.3-1 .7-1.3 1-.2.1-.4.1-.5-.2L6.6.9C6.5.7 6.3.6 6 .6H.3C.1.6 0 .7 0 .9V30c0 .2.1.3.3.3h6.6c.2 0 .3-.1.3-.3V13.7c0-1 .1-2 .3-2.9.1-.8.4-1.6.9-2.3.4-.6.9-1.1 1.6-1.5s1.5-.6 2.6-.6c1 0 1.9.2 2.6.6.7.4 1.3 1 1.7 1.7.4.7.7 1.5.9 2.3.2.9.3 1.8.3 2.6V30c0 .2.1.3.3.3H25c.2 0 .3-.1.3-.3V13.7c0-1 .1-2 .3-2.9.2-.9.5-1.7.9-2.3s1-1.2 1.6-1.5c.7-.4 1.5-.6 2.6-.6 1 0 1.9.2 2.6.6s1.3 1 1.7 1.7.7 1.5.9 2.3c.1 1 .1 1.9.1 2.7V30c0 .2.1.3.3.3h6.6z"
            />
          </defs>
          <clipPath id="metrovacesa_logo-short_svg__h">
            <use
              xlinkHref="#metrovacesa_logo-short_svg__g"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#metrovacesa_logo-short_svg__h)">
            <defs>
              <path id="metrovacesa_logo-short_svg__i" d="M0 0h116v31H0z" />
            </defs>
            <clipPath id="metrovacesa_logo-short_svg__j">
              <use
                xlinkHref="#metrovacesa_logo-short_svg__i"
                overflow="visible"
              />
            </clipPath>
            <path
              clipPath="url(#metrovacesa_logo-short_svg__j)"
              fill="#ffffff"
              d="M-5-5h125.9v40.9H-5z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgMetrovacesaLogoShort;
